<div class="h-pricing__table">
    <div class="h-carousel__track">
        <div class="row gx-5 card-group">
            <div class="col-md-6 col-12 col-lg-3">
                <div class="h-pricing-card__container">
                    <div class="h-pricing-card__title ">
                        <h3>Starter Tier</h3>
                    </div>
                    <div class="h-pricing-card__current-price">
                        $0
                    </div>
                    <p class="h-discount-tag">Always Free</p>
                    <p class="h-pricing-card__offer">
                        No Billing Information Required </p>

                    <!-- <p class="h-pricing-card__offer">Always Free</p> -->
                    <div class="h-pricing-card__separator"></div>
                    <div class="h-pricing-card__features--grouped">
                        <p class="h-pricing-card__feature-title">
                            Features Included :
                        </p>
                        <div class="h-plan-feature__content">
                            <ul>
                                <li>- 4 Uploads Per Month</li>
                                <li>- Create Profile</li>
                                <li>- Site Access</li>
                            </ul>
                        </div>
                        <div class="h-button">
                            <button class="h-button-primary" (click)="joinNow('starter_tier')">Join Now</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-12 col-lg-3">
                <div class="h-pricing-card__container">
                    <div class="h-pricing-card__title ">
                        <h3>Enthusiast Tier</h3>
                    </div>
                    <div class="h-pricing-card__current-price">
                        {{pacakges[1]?.per_month_charges | currency}} <span><sub>(monthly)</sub></span>
                    </div>
                    <p class="h-discount-tag">Save with an annual
                        membership</p>
                    <p class="h-pricing-card__offer">{{pacakges[1]?.yearly_per_month_charges * 12 | currency}}
                        (annually)</p>
                    <div class="h-pricing-card__separator"></div>
                    <div class="h-pricing-card__features--grouped">
                        <p class="h-pricing-card__feature-title">
                            Features Included :
                        </p>
                        <div class="h-plan-feature__content">
                            <ul>

                                <li>- 12 Uploads Per Month</li>
                                <li>- Grading Ability</li>
                                <li>- Messaging Ability</li>
                                <li> - Profile Customization</li>
                                <li> - Starter Tier Features</li>
                            </ul>
                        </div>
                        <div class="h-button">
                            <button class="h-button-primary" (click)="joinNow('enthusiast_tier')">Join Now</button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-md-6 col-12 col-lg-3">

                <div class="h-pricing-card__container">
                    <div class="h-pricing-card__title ">
                        <h3>Collector Tier</h3>
                    </div>
                    <div class="h-pricing-card__current-price">
                        {{pacakges[2]?.per_month_charges | currency}} <span><sub>(monthly)</sub></span>
                    </div>
                    <p class="h-discount-tag">Save with an annual
                        membership</p>
                    <p class="h-pricing-card__offer">{{pacakges[2]?.yearly_per_month_charges * 12 | currency}}
                        (annually)</p>
                    <div class="h-pricing-card__separator"></div>
                    <div class="h-pricing-card__features--grouped">
                        <p class="h-pricing-card__feature-title">
                            Features Included :
                        </p>
                        <div class="h-plan-feature__content">
                            <ul>
                                <li>- Unlimited Monthly Uploads</li>
                                <li>- Supplemental Identification </li>
                                <li><span class="visibility-hidden">- </span>Photos can be added</li>
                                <li> - View Member’s Assessment </li>
                                <li><span class="visibility-hidden">- </span>Reasoning</li>
                                <li>- Enthusiast Tier Benefits</li>
                            </ul>
                        </div>
                        <div class="h-button">
                            <button class="h-button-primary" (click)="joinNow('collector_tier')">Join Now</button>
                        </div>
                    </div>

                </div>

            </div>
            <div class="col-md-6 col-12 col-lg-3">

                <div class="h-pricing-card__container">
                    <div class="h-pricing-card__title ">
                        <h3>Elite Tier</h3>
                    </div>
                    <div class="h-pricing-card__current-price">
                        {{pacakges[3]?.per_month_charges | currency}} <span><sub>(monthly)</sub></span>
                    </div>
                    <p class="h-discount-tag">Save with an annual
                        membership</p>
                    <p class="h-pricing-card__offer">{{pacakges[3]?.yearly_per_month_charges * 12 | currency}}
                        (annually)</p>
                    <div class="h-pricing-card__separator"></div>
                    <div class="h-pricing-card__features--grouped">
                        <p class="h-pricing-card__feature-title">
                            Features Included :
                        </p>
                        <div class="h-plan-feature__content">
                            <ul>
                                <li>- Request Immediate Assessments
                                </li>
                                <li> <span class="visibility-hidden">- </span> from the Coin Curiosity Community</li>
                                <li> - Collector Tier Benefits</li>
                            </ul>
                        </div>
                        <div class="h-button">
                            <button class="h-button-primary" (click)="joinNow('elite_tier')">Join Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>